export default "__VITE_ASSET__af9e38b7__"